export default __webpack_public_path__ + "static/services-details1d-7e967e04667fb8f5d227c1b847c1c375.jpg";